module.exports = {
  src: __webpack_public_path__ + "static/media/individuals_00024.736f7294.jpg",
  width: 600,
  height: 750,
  bytes: 169638,
  type: "jpg",
};
module.exports.toString = function() {
  return __webpack_public_path__ + "static/media/individuals_00024.736f7294.jpg";
};


//////////////////
// WEBPACK FOOTER
// ./src/core/images/galleries/individuals/individuals_00024.jpg
// module id = 461
// module chunks = 0